import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        filter: '',
    },
    reducers: {
        updateFilter: (state, action) => ({
            filter: action.payload
        }),
    },
});

export const { updateFilter } = filterSlice.actions;
export const filterReducer = filterSlice.reducer;

// Selectors
export const getFilterValue = state => state.filter.filter;
